import { render } from "./SummRy.vue?vue&type=template&id=2b138b39&scoped=true"
import script from "./SummRy.vue?vue&type=script&lang=js"
export * from "./SummRy.vue?vue&type=script&lang=js"

import "./SummRy.vue?vue&type=style&index=0&id=2b138b39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b138b39"]])

export default __exports__